module.exports = __webpack_public_path__ + "static/media/close.aca365ba.svg";